'use client'

import { Switch } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

type Props = {
  name: string
  checked?: boolean
  className?: string
  label: string | React.ReactNode
  disabled?: boolean
  onChange: (val: any) => void
} & React.ComponentPropsWithoutRef<'input'>

const Toggle = (props: Props) => {
  const { name, checked, label, onChange } = props
  function handleChange(val: boolean) {
    onChange(val)
  }
  return (
    <Switch name={name} checked={checked} onChange={handleChange} className={twMerge('group flex items-center w-fit')}>
      <div className='relative inline-flex h-5 w-10 shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-hidden'>
        <span aria-hidden='true' className={twMerge('pointer-events-none absolute size-full rounded-md')} />
        <span
          aria-hidden='true'
          className={twMerge(
            'pointer-events-none absolute mx-auto h-4 w-9 rounded-full',
            'bg-zinc-200 dark:bg-zinc-700 transition-colors duration-200 ease-in-out group-data-checked:bg-red-800',
          )}
        />
        <span
          aria-hidden='true'
          className={twMerge(
            'pointer-events-none absolute left-0 inline-block size-5 transform rounded-full',
            'border border-zinc-300 dark:border-zinc-500 bg-white dark:bg-zinc-900',
            'ring-0 shadow-sm transition-transform duration-200 ease-in-out',
            'group-data-checked:translate-x-5',
          )}
        />
      </div>
      <span className='text-base md:text-sm font-medium px-3'>{label}</span>
    </Switch>
  )
}

export default Toggle
